import React, { useMemo } from 'react'
import Avatar from 'react-avatar'

/**
 * Props:
 *  - name: string (tên, dùng để lấy initials)
 *  - src: string | null (url ảnh)
 *  - size: number (mặc định 32)
 */
export default function AvatarCustom({ name = '', src = null, size = 32 }) {
  // Tạo màu ngẫu nhiên 1 lần cho mỗi mount (useMemo để ổn định trong lifecycle)
  const randomBg = useMemo(() => {
    // palette bạn có thể thay đổi
    const palette = [
      // Đỏ & Hồng
      '#E53935',
      '#F44336',
      '#FF5252',
      '#D32F2F',
      '#C62828',
      '#D81B60',
      '#E91E63',
      '#F06292',
      '#AD1457',
      '#C2185B',
      '#8E24AA',
      '#9C27B0',
      '#AB47BC',
      '#7B1FA2',
      '#6A1B9A',

      // Tím & Indigo
      '#5E35B1',
      '#673AB7',
      '#7E57C2',
      '#512DA8',
      '#4527A0',
      '#3949AB',
      '#3F51B5',
      '#5C6BC0',
      '#303F9F',
      '#283593',

      // Xanh dương
      '#1E88E5',
      '#2196F3',
      '#42A5F5',
      '#1976D2',
      '#1565C0',
      '#039BE5',
      '#03A9F4',
      '#29B6F6',
      '#0288D1',
      '#0277BD',

      // Xanh ngọc & Lục
      '#00897B',
      '#009688',
      '#26A69A',
      '#00796B',
      '#00695C',
      '#43A047',
      '#4CAF50',
      '#66BB6A',
      '#388E3C',
      '#2E7D32',

      // Vàng & Cam
      '#FDD835',
      '#FFEB3B',
      '#FFF176',
      '#FBC02D',
      '#F9A825',
      '#FB8C00',
      '#FF9800',
      '#FFB74D',
      '#F57C00',
      '#EF6C00',
      '#F4511E',
      '#FF7043',
      '#E64A19',
      '#D84315',
      '#BF360C',

      // Nâu & Xám
      '#6D4C41',
      '#795548',
      '#8D6E63',
      '#5D4037',
      '#4E342E',
      '#757575',
      '#9E9E9E',
      '#BDBDBD',
      '#616161',
      '#424242',
      '#546E7A',
      '#607D8B',
      '#78909C',
      '#455A64',
      '#37474F'
    ]
    return palette[Math.floor(Math.random() * palette.length)]
  }, [])

  // react-avatar sẽ ưu tiên src nếu hợp lệ; color chỉ áp dụng khi không có ảnh
  return (
    <Avatar
      name={name}
      src={src || undefined}
      round={true}
      size={size}
      // nếu bạn muốn text size tùy chỉnh:
      textSizeRatio={2}
      // chỉ đặt màu khi không có src
      color={src ? undefined : randomBg}
      // số chữ cái tối đa hiển thị (ví dụ 2 => "MS")
      maxInitials={2}
      // style để chắc chắn width/height là pixel chẵn
      style={{ width: size, height: size, lineHeight: `${size}px` }}
    />
  )
}
